<template>
<section class="container content">
  <div class="level">
    <h1 class="level-left title">Checkout</h1>
    <router-link :to="moreBooksLink" class="level-right button is-light is-large">
      <b-icon icon="chevron-double-left"/>&nbsp;...or add more books</router-link>
  </div>
  <form @submit.prevent="onSubmit">
      <div class="column content box">
        <!-- NOTE reactivity is broken under google translate so
             class="notranslate" for important fields -->
        <table class="table">
          <tr class="header">
            <th>Book</th>
            <td class="price">Price</td>
            <td>Quantity</td>
            <td class="price">Line Total</td>
          </tr>
          <tr v-for="item in lineItems" class="line-item notranslate">
            <td>
              <span class="line-title" v-html="item.coverTitle"/>
              <b-tooltip v-if="item.noteToSelf" :label="item.noteToSelf">
                <b-icon type="is-warning" icon="note"/>
              </b-tooltip>
              <br>&mdash;<span class="line-author" v-html="item.coverAuthor"/>
              <br>
              <span class="line-desc" v-if="item.bookReady">{{item.pageCount}} pages</span>
              <span class="line-desc" v-else>(NOT READY!!)</span>
            </td>
            <td class="price">{{item.price | formatCurrency}}</td>
            <td>
              <b-select v-model="item.quantity" size="is-small" @input="updateCartItem(item)">
                <option :value="0">0</option>
                <option v-for="q in possibleQuantities" :value="q">x{{q}}</option>
              </b-select>
            </td>
            <td class="price">
              <span v-if="item.quantity">{{calcPrice(item) | formatCurrency}}</span>
              <b-tooltip v-else multilined type="is-light" label="Remove from Order">
                <b-icon icon="delete" @click.native="deleteCartItem(item)"/>
              </b-tooltip>
            </td>
          </tr>
          
          <tr>
            <td>Shipping</td>
            <td></td>
            <td></td>
            <td class="price">
              <span v-if="shippingPrice" class="notranslate">{{shippingPrice | formatCurrency}}</span>
              <span v-else><em>Free</em></span>
            </td>
          </tr>
          
          <!--tr><td colspan="2"><b-input v-model="promoCode" placeholder="Promotional Code"/></td>
              <td class="price"> <span v-if="promoPrice">{{promoPrice | formatCurrency}}</span>
        </td></tr-->

          <tr class="footer">
            <td>Total</td>
            <td></td>
            <td><currency-selector/></td>
            <td class="price notranslate">{{$store.state.currencySymbol}}{{totalPrice | formatCurrency}}</td>
          </tr>
        </table>
      </div>
      
    <div class="columns">
      <div class="column content">
        <div v-if="$store.state.user.isAnonymous">
          <h3 class="subtitle">Card Holder</h3>
          <b-field>
            <b-input id="email" name="email" placeholder="Email"
                     icon="email" type="email" autocomplete="email"
                     v-model="fields.email" required></b-input>
          </b-field>
        </div>
        <div>
          <h3 class="subtitle">Shipping Address</h3>
          <b-field label="Full Name" label-position="on-border">
            <b-input name="ship_name" icon="account"
                     autocomplete="shipping name" v-model="fields.ship.name" required></b-input>
          </b-field>
          <b-field label="Country" label-position="on-border" class="is-expanded">
            <b-select name="ship_country"
                      placeholder="Country" icon="earth"
                      autocomplete="shipping country"  v-model="fields.ship.country"
                      expanded required>
              <option v-for="c in countries.All" :value="c.code3">{{c.name}}</option>
            </b-select>
          </b-field>
          <!--span class="no-po-box">Delivery may require a signature, so no PO Boxes
          or Lockers please!</span-->
          <b-field label="Address" label-position="on-border">
            <b-input name="ship_address"
                     icon="home" autocomplete="shipping address-line1"
                     v-model="fields.ship.address" required></b-input>
          </b-field>
          <b-field>
            <b-input name="ship_address2" placeholder="(optional)"
                     icon="ellipsis" autocomplete="shipping address-line2"
                     v-model="fields.ship.address2"></b-input>
          </b-field>
          <b-field label="City" label-position="on-border">
            <b-input name="ship_city" autocomplete="shipping address-level2"
                     icon="city" v-model="fields.ship.city" required></b-input>
          </b-field>
          <b-field v-if="countries.States[fields.ship.country]"
                     label="State" label-position="on-border" class="is-expanded">
            <b-select
                      name="ship_state" icon="earth"
                      autocomplete="shipping address-level1"  v-model="fields.ship.state"
                      expanded required>
              <option v-for="c in countries.States[fields.ship.country]" :value="c.code">{{c.name}}</option>
            </b-select>
          </b-field>
          <b-field v-else label="State" label-position="on-border" class="is-expanded">
            <b-input
                     name="ship_state" icon="earth"
                     autocomplete="shipping address-level1"
                     v-model="fields.ship.state" expanded></b-input>
          </b-field>
          <b-field label="ZIP or Postal Code" label-position="on-border" class="is-expanded">
            <b-input name="ship_postcode" icon="earth"
                     autocomplete="shipping postal-code"
                     v-model="fields.ship.postcode" expanded required></b-input>
          </b-field>
          <b-field label="Phone" label-position="on-border">
            <b-input id="phone" name="phone" placeholder="(required by some shippers)"
                     icon="phone" autocomplete="tel" v-model="fields.phone"
                     maxlength="20" required></b-input>
          </b-field>
          <b-field>
            <b-checkbox v-model="addBillingAddress">Add a different billing address
            </b-checkbox>
          </b-field>
          <div v-if="addBillingAddress">
            <h3 class="subtitle">Card Billing Address</h3>
            <b-field label="Name on Card" label-position="on-border">
              <b-input name="bill_name" icon="account"
                       autocomplete="name" v-model="fields.bill.name" required></b-input>
            </b-field>
            <b-field label="Country" label-position="on-border" class="is-expanded">
              <b-select name="bill_country" icon="earth"
                        autocomplete="country-name"  v-model="fields.bill.country"
                        expanded required>
                <option v-for="c in countries.All" :value="c.code3">{{c.name}}</option>
              </b-select>
          </b-field>
            <b-field label="Address" label-position="on-border">
              <b-input name="bill_address"
                       icon="home" v-model="fields.bill.address" required></b-input>
            </b-field>
            <b-field label="City" label-position="on-border">
              <b-input name="bill_city" autocomplete="city"
                       icon="city" v-model="fields.bill.city" expanded required></b-input>
            </b-field>
            <b-field v-if="countries.States[fields.bill.country]"
                     label="State" label-position="on-border" class="is-expanded">
              <b-select name="bill_state" icon="earth"
                        autocomplete="address-level1"  v-model="fields.bill.state"
                        expanded required>
                <option v-for="c in countries.States[fields.bill.country]" :value="c.code">{{c.name}}</option>
              </b-select>
            </b-field>
            <b-field v-else label="State" label-position="on-border" class="is-expanded">
              <b-input
                       name="bill_state" icon="earth"
                       v-model="fields.bill.state" expanded requried></b-input>
            </b-field>
            <b-field label="ZIP or Postal Code" label-position="on-border" class="is-expanded">
              <b-input name="bill_postcode" icon="earth"
                       autocomplete="postal-code"  v-model="fields.bill.postcode" expanded required></b-input>
            </b-field>
          </div>
        </div>
    </div>
    <div class="column content">
      <h3 class="subtitle">Card Payment</h3>
      <card class="stripe-card field box"
            :class="{ cardComplete }"
            :stripe="stripeInstance"
            :stripe-key="stripePublishableKey"
            :options="cardOptions"
            @change="onCardChange"></card>
      <div class="payment-provider">
        <a href="https://stripe.com" target="_blank"><img src="/static/powered_by_stripe.png"/></a>
      </div>

      <b-field v-if="requiresContentAgreement">
        <b-checkbox v-model="fields.agreeContent"><em>I confirm that I
          am the owner of this blog or instagram content or have the
          permission of the content owner to transform the content into
          a book.</em>
        </b-checkbox>
      </b-field>
      <b-field>
        <b-checkbox v-model="fields.agreeTerms"><em>I understand and
          agree to the <router-link to="/doc/terms">terms and
          conditions</router-link>, in particular that PixxiBook has no
          editorial control over the</em> content.
        </b-checkbox>
      </b-field>
      <b-message v-if="submitAttempted && validationErrors.length" class="is-danger">
        Please correct the following:
        <ul><li v-for="e in validationErrors">{{e}}</li></ul>
      </b-message>
      <b-message v-if="submitAttempted && tokenError && !validationErrors" class="is-danger">
        Payment failed:
        <ul><li>{{tokenError}}</li></ul>
      </b-message>
      <div class="level">
        <div class="level-left">
          <!--router-link to="/mybooks" class="button is-large">
            <b-icon icon="chevron-double-left"/> Keep shopping...</router-link-->
        </div>
        <div class="level-right">
          <input type="submit"
                 class="button is-primary pay-with-stripe is-large"
                 :disabled="!canSubmit || submitBusy"
                 @click="onPayAttempt"
                 :value="payButtonText"></input>
        </div>
      </div>
    </div>
    </div>
  </form>

    <b-modal :active="submitBusy" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"></p>
        </header>
  
        <section class="modal-card-body">
          <div class="content">
            <div v-if="tokenError">
              <h2>Card Error.</h2>
              <p>{{tokenError}}</p>
            </div>
            <div v-else-if="orderStatus">
              <div v-if="orderStatus.status=='charged'">
                <h2>Success!</h2>
                <p><b>Thank you for entrusting your book to PixxiBook.</b></p>
                <p>Please check your order confirmation email!</p>

                <p><ul>
                    <li> This book is now locked from further editing.</li>
                    <li> We will email further updates as your book is produced and shipped.</li>
                    <li> Please do not delete your blog until you receive your order.</li>
                    <li> See all your books and create new ones from your <router-link to="/mybooks">My
                        Books</router-link> page.</li>
                </ul></p>
              </div>
              <div v-else-if="orderStatus.status=='failed'">
                <h2>A problem occured</h2>
                Sorry, server says: "{{orderStatus.error}}"<br>
                Something has gone tragically wrong - please contact us. 
              </div>
              <div v-else-if="orderStatus.status=='refused'">
                <h2>Payment Error</h2>
                Apparently, "{{orderStatus.error}}"</div>
              <div v-else-if="orderStatus.status=='authorising'">
                <h2>Authorization required</h2>
                Please follow your bank's instructions...
                </div>
              <div v-else>
                <h2>We are charging your card</h2>
                This may take a few seconds....</div>
            </div>
            <div v-else>
              <h2>We are checking the order.</h2>
              Just a moment...</div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <div class="level">
            <div class="level-left"> </div>
            <div class="level-right">
              <button class="button"
                      v-if="tokenError || (orderStatus && (orderStatus.status=='failed' || orderStatus.status=='refused'))"
                      @click="onBack">Back</button>
              <button class="button is-primary"
                      v-if="orderStatus && orderStatus.status=='charged'"
                      @click="onDone">Go to My Books</button>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
    
  
</section>
</template>

<script>
import Pricer from '../pricer.js'
import Countries from '../countries.js'
import ActionLog from '../actionlog.js'
import Firebase from '../firebase.js'
import CurrencySelector from '@/components/CurrencySelector'
var db = Firebase.database

//import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken, createPaymentMethod, handleCardAction } from 'vue-stripe-elements-plus'

var CardOptions = {
  classes: { base: 'control' },
  style: { base: { fontFamily: 'BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
                   fontSize: '16px' } },
  card: { hidePostalCode: true },
  hidePostalCode: true,
}

function range(j, k) {
  return Array
    .apply(null, Array((k - j) + 1))
    .map(function(_, n){ return n + j; });
}
function projidFromBookId(bookid) {
  return bookid.split('/')[0]
}
function volidFromBookId(bookid) {
  return bookid.split('/')[1]
}


var POSSIBLE_QUANTITIES = range(1,50)

export default {
  name: 'CheckoutPage',
  components: {
    Card,
    CurrencySelector,
  },
  metaInfo() { return {
    title: 'Checkout',
  }},
  data: function() { return {
    possibleQuantities: POSSIBLE_QUANTITIES,
    cardComplete: false,
    cardError: undefined,
    tokenError: undefined,
    cardOptions: CardOptions,
    addBillingAddress: false,
    lineItems: {},
    quantity: 1,
    promoCode: '',
    submitAttempted: false,
    submitBusy: false,
    orderRef: false,
    orderStatus: false,
    fields: {
      email: this.$store.state.user.email,
      phone: undefined,
      ship: {
        name: undefined,
        address: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        postcode: undefined,
        country: 'USA',
      },
      bill: {
        name: undefined,
        address: undefined,
        city: undefined,
        state: undefined,
        postcode: undefined,
        country: undefined,
      },
      agreeContent: false,
      agreeTerms: false,
    },
    selections: false,
    renderStatsPageCount: false,
  }},
  computed: {
    countries: function() {
      return Countries
    },
    user: function() {
      return this.$store.state.user;
    },
    moreBooksLink: function() {
      console.log('moreBooksLink', this.$route.query.shop)
      if (this.$route.query.shop) {
        return '/shop/' + this.$route.query.shop
      } else {
        return '/mybooks'
      }
    },
    cartItems: function() {
      return this.$store.state.cart.items
    },
    currency: function() {
      return this.$store.state.currency
    },
    stripeInstance: function() {
      return window.Stripe(this.stripePublishableKey)
    },
    stripePublishableKey: function() {
      if (this.$store.state.dev.testPayments) {
        return 'pk_test_DRpcuqLCJMbO1Dzakq4ennrl'
      }
      return 'pk_live_BDPtWmRUfLVqFsu97FG5xXkF'
    },
    pageCount: function() {
      console.log('recalc pageCount')
      if (this.renderStatsPageCount && this.selections && this.selections.selectedPosts) {
        var totalPages = 0
        var uncounted = 0
        this.selections.selectedPosts.forEach( p => {
          if (this.renderStatsPageCount[p] !== undefined) totalPages += this.renderStatsPageCount[p]
          else uncounted++
        })
        if (uncounted) {
          var totalPosts = this.selections.selectedPosts.length
          var countedPosts = ((totalPosts - uncounted) || 1)
          totalPages = Math.floor(totalPages * totalPosts / countedPosts)
        }
        if (this.selections.coverShowTitlePage) totalPages += 2
        return totalPages
      }
      return 4;
    },
    allBooksReady: function() {
      return Object.keys(this.lineItems).every( k => this.lineItems[k].bookReady )
    },
    pageCountWithCovers: function() {
      return this.pageCount
    },
    itemTotalPrice: function() {
      var prices = Object.keys(this.lineItems)
          .map(k => this.calcPrice(this.lineItems[k]))
      console.log('prices:', prices)
      return prices ? prices.reduce((a,b) => a+b, 0) : 0
    },
    shippingPrice: function() {
      if (this.itemTotalPrice == 0) return 0
      return Pricer.shippingPrice('a4', 100, this.itemTotalPrice, this.$store.state.currency)
    },
    promoPrice: function() {
      //if (this.promoCode=="XMAS2018") return this.totalPrice * -0.3
      return 0
    },
    totalPrice: function() {
      return this.itemTotalPrice + this.shippingPrice
    },
    printedPageCount: function() {
      return Pricer.padPageCount(this.selections.format, this.pageCountWithCovers)
    },
    validationErrors: function() {
      var errs = []
      if (!this.allBooksReady) {
        errs.push('Some books are not ready for printing! Please return to the preview.')
        return errs
      }
      if (!this.fields.email) {
        errs.push('Your email address is incomplete (and not signed in)')
      }
      if (!this.fields.ship.name.trim().includes(' ')) {
        errs.push('Please specify your Full Name for shipping')
      }
      if (!this.fields.ship.name ||
          !this.fields.ship.address || !this.fields.ship.city ||
          (this.countries.States[this.fields.ship.country] && !this.fields.ship.state) ||
          !this.fields.ship.postcode || !this.fields.ship.country || !this.fields.phone) {
        errs.push('Your Shipping Address is incomplete')
      }
      if (this.addBillingAddress &&
          !this.fields.bill.name.trim().includes(' ')) {
        errs.push('Please specify your Full Name for billing')
      }
      if (this.addBillingAddress &&
          (!this.fields.bill.name ||
           !this.fields.bill.address || !this.fields.bill.city ||
           (this.countries.States[this.fields.bill.country] && !this.fields.bill.state) ||
           !this.fields.bill.postcode || !this.fields.bill.country)) {
        errs.push('Your Billing Address is incomplete')
      }
      if (this.cardError) {
        errs.push(this.cardError)
      } else if (!this.cardComplete) {
        errs.push('Your card details are incomplete')
      }
      if (this.requiresContentAgreement && !this.fields.agreeContent) {
        errs.push('You must comfirm content permissions')
      }
      if (!this.fields.agreeTerms) {
        errs.push('You must agree to terms and conditions')
      }
      return errs
    },
    canSubmit: function() {
      return this.totalPrice > 0
       && (!this.submitAttempted
           || this.validationErrors.length==0
           || (this.$store.state.dev.developmentClient && this.$store.state.dev.testPayments)
          )
    },
    payButtonText: function() {
      if (this.totalPrice) {
        var price = parseInt(this.totalPrice/100)
        return 'Pay ' + this.$store.state.currencySymbol + price + ' by Card'
      } else {
        return 'Pay by Card'
      }
    },
    requiresContentAgreement: function() {
      const items = Object.values(this.lineItems)
      const isPureShopOrder = items.every( i => i.quantity==0 || i.isGalleryOrder)
      return !isPureShopOrder
    }
  },
  methods: {
    onCardChange: function(ev) {
      this.cardComplete = ev.complete
      this.cardError = ev.error ? ev.error.message : undefined
    },
    onPayAttempt: function() {
      this.submitAttempted = true
      if (this.canSubmit) {
        this.createPayment()
      }
    },
    createPayment: function() {
      this.submitBusy = true
      var a = this.addBillingAddress ? this.fields.bill : this.fields.ship
      console.log('PAY!')

      var payment = createPaymentMethod('card', {
        billing_details: { name: a.name,
                           email: this.fields.email,
                           address: {
                             line1: a.address,
                             city: a.city,
                             state: a.state,
                             postal_code: a.postcode,
                             country: this.countries.iso3to2[a.country]
                           }}
      })
      
      payment.then(result => {
        console.log(result)
        if (result.error) {
          this.tokenError = result.error.message
          console.log("Stripe Payment Error:", result.error)
        } else {
          this.tokenError = undefined
          var order = this.makeOrder({ token: result.token,
                                       id: result.paymentMethod.id })
          console.log("Stripe Payment OK:", order)
          var osub = this.$store.state.dev.testPayments ? 'test' : 'live'
          this.orderRef = db.ref('/orders/'+osub).push()
          console.log('writing order to "'+this.orderRef.key+'"')
          this.orderRef.set(order, error => {
            if (error) {
              this.tokenError = "FAILURE: " + error
            }
            this.$bindAsObject("orderStatus", this.orderRef.child('status'))
            try {
              this.$ga.event('Conversions', 'Pay', this.$route.path)
              this.$ga.ecommerce.addTransaction({
                id: this.orderRef.key,
                revenue: order.params.product.price_total/100,
                shipping: order.params.product.price_shipping/100,
                currency: order.params.product.price_currency,
              })
              this.$ga.ecommerce.send()
            } catch (error) {
              console.error(error)
            }
          })
          ActionLog('order_attempt', {items: Object.keys(this.lineItems)})
        }
      })
    },
    cleanObject: function(obj) {
      var ret = {}
      Object.keys(obj).forEach( k => {
        if (obj[k]!==undefined) ret[k] = obj[k]
      })
      return ret
    },
    makeOrder: function(paymentInfo) {
      var cleanedFields = this.cleanObject(this.fields)
      cleanedFields.ship = this.cleanObject(this.fields.ship)
      cleanedFields.bill = this.cleanObject(this.fields.bill)
      var productItems = Object.keys(this.lineItems)
          .filter( k => this.lineItems[k].quantity && this.lineItems[k].bookReady )
          .map( k => {
            var item = this.lineItems[k]
            return { bookid: item.bookid || k,
                     title: item.coverTitle + (item.coverAuthor ? ' - ' + item.coverAuthor : ''),
                     page_count: item.pageCount,
                     price_item: item.price,
                     quantity: item.quantity,
                     format: item.format,
                     isReorder: item.isReorder,
                     creatorUid: item.creatorUid || '',
                     isShopOrder: item.isGalleryOrder || false }
          })

      return {
        uid: this.user.uid,
        params: {
          product: {
            price_shipping: this.shippingPrice,
            price_promo: this.promoPrice,
            price_total: this.totalPrice,
            promo_code: this.promoCode,
            price_currency: this.$store.state.currency,
            product_items: productItems,
          },
          fulfilment: cleanedFields,
        },
        status: {
          status: 'created',
          operations: [
            { old_status: '', new_status: 'created', info: 'Order placed',
              by: this.user.uid, timestamp:  {'.sv': 'timestamp'} },
          ],
        },
        billing: {
          stripe_token: paymentInfo.token || false,
          stripe_payment_method_id: paymentInfo.id || false,
        },
        is_test: this.$store.state.dev.testPayments,
      }
    },
    onSubmit: function() {
      //eat submits. submit forces form validation but we will submit
      //manually after we get the token.
      console.log("Submitting...")
    },
    onBack: function() {
      if (this.orderStatus) this.$unbind('orderStatus')
      this.tokenError = false
      this.orderStatus = false
      this.submitBusy = false
    },
    onDone: function() {
      this.$router.replace('/mybooks')
    },
    calcPrice: function(lineItem) {
      if (!lineItem.bookReady) return 99999
      return lineItem.price * lineItem.quantity
    },
    refreshLineItem: function(bookid, quantity) {
      //TODO - refresh on change of currency
      console.log('Refreshing line item', bookid, quantity)
      if (bookid.startsWith('gallery::')) {
        this.refreshGalleryLineItem(bookid, quantity)
      } else {
        this.refreshProjectLineItem(bookid, quantity)
      }
    },
    
    refreshGalleryLineItem: function(galleryid, quantity) {
      console.log('Refreshing gallery line item', galleryid)
      const gallerypath = galleryid.substr(9)
      db.ref("/gallery/"+gallerypath).once('value', snap => {
        const gallery = snap.val()
        console.log('gallery line item:', gallery)
        var lineItem = this.lineItems[galleryid]
        lineItem.isValid = true
        lineItem.creatorUid = gallery.uid
        lineItem.itemid = galleryid
        lineItem.bookid = gallery.projid //TODO: needs bookid with vol#!
        lineItem.format = gallery.format
        lineItem.coverTitle = gallery.title
        lineItem.coverAuthor = gallery.author || ''
        lineItem.noteToSelf = undefined 
        lineItem.quantity = quantity
        lineItem.isReorder = true
        lineItem.isGalleryOrder = true
        const totalPages = gallery.content_pages || 0
        lineItem.bookReady = totalPages > 0
        lineItem.pageCount = totalPages
        lineItem.price = Pricer.calculatePrice(gallery.format, totalPages, this.$store.state.currency)            
        console.log('gallery line item:', this.lineItems[galleryid])
        this.$set(this.lineItems, galleryid, lineItem)
     })
    },  
    refreshProjectLineItem: function(bookid, quantity) {
      const projid = projidFromBookId(bookid)
      const volid = volidFromBookId(bookid)
      console.log('Refreshing project line item', bookid, projid, volid)
      
      var projref = db.ref("/projects/"+this.$store.state.uid+"/"+projid)
      projref.child('selections').once('value', snap => {
        var selections = snap.val()
        if (selections) {
          var lineItem = this.lineItems[bookid]
          lineItem.isValid = !!volume
          lineItem.creatorUid = ''
          lineItem.itemid = bookid
          lineItem.bookid = bookid
          lineItem.isGalleryOrder = false
          var volume = volid ? selections.volumes[volid] : selections
          console.log('refreshLineItem', bookid, selections)
          //lineItem.projid = projid
          //lineItem.bookReady = 0
          lineItem.format = selections.format
          lineItem.coverTitle = volume.coverTitle
          lineItem.coverAuthor = volume.coverAuthor
          lineItem.noteToSelf = volume.noteToSelf
          //lineItem.price = 99999
          lineItem.quantity = quantity
          this.$set(this.lineItems, bookid, lineItem)

          projref.child('isLocked').once('value', snap => {
            console.log('lineitem', bookid, 'isLocked==',snap.val())
            this.$set(this.lineItems[bookid], 'isReorder', !!snap.val())
          })

          var renderTags = selections.format+'_draft'
          if (selections.styleHash) {
            renderTags += '_'+selections.styleHash
          }

          var pcpath = ['/renders', this.$store.state.uid, projid,
                        renderTags, 'stats/pagecounts'].join('/')
          db.ref(pcpath).once('value', snap => {
            var pageCounts = snap.val()
            var totalPages = 0
            var uncounted = 0
            try {
              volume.selectedPosts.forEach( p => {
                if (pageCounts[p] !== undefined) totalPages += pageCounts[p]
                else uncounted++
              })
              if (volume.coverShowTitlePage) totalPages += 2
            } catch(error) {
              totalPages = 0
            }
            this.$set(this.lineItems[bookid], 'bookReady', (uncounted == 0) && (totalPages > 4))
            this.$set(this.lineItems[bookid], 'pageCount', totalPages)
            this.$set(this.lineItems[bookid], 'price', Pricer.calculatePrice(selections.format,
                                                                             totalPages,
                                                                             this.$store.state.currency))
            
            console.log('previewpath', pcpath, totalPages, uncounted)
            console.log(this.lineItems[bookid])
            //this.$forceUpdate() //!!
          })
        }
      })
    },
    refreshCartItems: function(items) {
      console.log('refreshCartItems:', items)
      Object.keys(this.lineItems).forEach( bookid => {
        if (!bookid || items[bookid]===undefined) {
          this.$delete(this.lineItems, bookid)
        }
      })
      if (items) {
        Object.keys(items).forEach( bookid => {
          if (!this.lineItems[bookid]) {
            this.$set(this.lineItems, bookid, { bookid: bookid,
                                                bookReady: 0,
                                                quantity: items[bookid],
                                                price: 99999,
                                                pageCount: 2})
          }
          this.refreshLineItem(bookid, items[bookid])
        })
      } else {
        this.lineItems = {}
      }
    },
    updateCartItem: function(item) {
      var cartItem = { bookid: item.itemid || item.bookid, quantity: item.quantity }
      console.log("add to cart", cartItem)
      this.$store.dispatch('addToCart', cartItem)
    },
    deleteCartItem: function(item) {
      console.log("remove from cart", item)
      this.$store.dispatch('removeFromCart', item.itemid || item.bookid)
    },
  },
  watch: {
    'cartItems': function(items) {
      console.log('cartItems:', items)
      this.refreshCartItems(items)
    },
    'currency': function(currency) {
      console.log('currency changed:', currency)
      this.refreshCartItems(this.cartItems)
    },
    'orderStatus.status': function(newStatus, oldStatus) {
      if (newStatus != oldStatus) {
        if (newStatus == 'charged') {
          ActionLog('order_ok', {items: Object.keys(this.lineItems)})
          this.$store.dispatch('clearCart')
        } else if (newStatus == 'charging') {
          //nada...
        } else if (newStatus == 'authorising') {
          var operation = this.orderStatus.operations.slice(-1).pop()
          if (operation && operation.info && operation.info.stripe_intent) {
            var stripe_intent = operation.info.stripe_intent
            ActionLog('order_auth', {items: Object.keys(this.lineItems)})
            this.$nextTick( () => {
              this.stripeInstance.handleCardAction(stripe_intent.client_secret).then(result => {
                console.log('auth action done =>', result)
                return this.$http.post('https://us-central1-omnipress-747.cloudfunctions.net/stripeConfirmationWebhook',
                                       { orderId: this.orderRef.key,
                                         orderList: this.$store.state.dev.testPayments ? 'test' : 'live',
                                         stripe_payment_intent_id: (result.paymentIntent||{}).id,
                                         stripe_payment_auth_error: result.error },
                                       { headers: { 'Content-Type': 'application/json' } })

              }).catch( error => {
                console.error('confirmation gone wrong:', error)
                ActionLog('order_conffail', {items: Object.keys(this.lineItems)})
                this.orderStatus.status = 'failed'
              })
            })
          } else {
            console.error('invalid order authorising data!', operation)
          }
        } else if (newStatus == 'failed' || newStatus == 'refused') {
          ActionLog('order_fail', {items: Object.keys(this.lineItems)})
        }
      }
    },
  },
  beforeMount: function() {
    var bookid = this.$route.query.add
    
    if (bookid && (!this.lineItems[bookid] || this.lineItems[bookid].quantity <= 0)) {
      var lineitem = { bookid: bookid, quantity: -1 } //special force min 1
      this.$store.dispatch('addToCart', lineitem)
    }

    this.$nextTick( () => {
      this.refreshCartItems(this.$store.state.cart.items)
    })
  },
}
</script>

<style scoped>
section.container {
  margin-top: 2em;
  margin-bottom: 2em;
}
.no-po-box {
  font-style: italic;
  font-size: 90%;
}

.line-author {
  font-style: italic;
}
.line-desc {
  padding-left: 2ex;
  font-style: italic;
  color: grey;
}

.payment-provider {
    float: right;
}
.level {
    width: 100%;
}
.button {
    min-width: 8em;
}
ul, li+li { margin-top: 0; }
.price {
    text-align: right;
    min-width: 6ex;
}

.book-not-ready {
    color: red;
}

tr.header td { font-weight: bold; }
tr.footer td { font-weight: bold; }

</style>



// WEBPACK FOOTER //
// src/components/CheckoutPage.vue